module.exports = __webpack_public_path__ + "static/img/PFK_OurStory_Photo6_390x390.e9c1bf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurStory_Photo6_390x390.jpg
// module id = 334
// module chunks = 2